import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="purchase-applications"
export default class extends Controller {
	static targets = [
		"template",
		"base",
		"text",
		"reason",
		"delete_check",
		"item_ids",
		"select",
	]

	static values = {
		purchaseItemSearchUrl: String,
		textData: Array,
	}

	connect() {
		this.set_value()
		this.baseTarget.style = "display:none;"
	}

	text_add() {
		const clone_id = this.textTarget.value
		if (this.judgement_added_text(clone_id)) {
			alert("そのテキストは追加済みです。")
			return false
		} else {
			const clone_target = this.baseTarget.cloneNode(true)
			const selected_text = this.textDataValue.find(
				(data) => data.id == clone_id
			)

			const clone_length = this.baseTargets.length
			clone_target.id = clone_id
			clone_target.querySelector("input").value = clone_id
			clone_target.querySelector(".text_name").textContent = selected_text.name
			clone_target.querySelector(
				".text_amount"
			).textContent = `${selected_text.amount}円`

			clone_target.querySelector(".course_id").value = clone_id
			clone_target.querySelector(
				".course_id"
			).id = `forms_purchase_applications_edit_texts_attributes_${clone_length}_course_id`
			clone_target.querySelector(
				".course_id"
			).name = `forms_purchase_applications_edit[texts_attributes][${clone_length}][course_id]`
			this.fetch_reason_kind(clone_target)
			clone_target.querySelector(
				".reason_kind"
			).id = `forms_purchase_applications_edit_texts_attributes_${clone_length}_reason_kind`
			clone_target.querySelector(
				".reason_kind"
			).name = `forms_purchase_applications_edit[texts_attributes][${clone_length}][reason_kind]`
			clone_target.style = ""
			this.templateTarget.append(clone_target)
		}
	}

	delete_added_text() {
		if (this.judgement_checked(this.delete_checkTargets)) {
			if (confirm("選択したテキストを削除しますか？")) {
				this.delete_checkTargets.forEach((del) => {
					this.baseTargets.forEach((target) => {
						if (del.checked && target.id === del.value) {
							target.remove()
						}
					})
				})
			}
			this.set_value()
		} else {
			alert("削除するテキストを選択してください。")
		}
	}

	judgement_checked(targets) {
		let delete_flg = false
		targets.forEach((target) => {
			if (target.checked) {
				delete_flg = true
			}
		})
		return delete_flg
	}

	fetch_reason_kind(target) {
		this.reasonTargets.forEach((reason) => {
			if (reason.checked) {
				target.querySelector(".reason_kind").value = reason.value
			}
		})
	}

	judgement_added_text(clone_id) {
		let added_flg = false
		this.item_idsTargets.forEach((id) => {
			if (id.value === clone_id) {
				added_flg = true
			}
		})
		return added_flg
	}

	set_value() {
		this.baseTargets.forEach((target, index) => {
			const course_id = target.querySelector(".course_id").value
			target.id = course_id
			target.querySelector("input").value = course_id

			target.querySelector(
				".course_id"
			).id = `forms_purchase_applications_edit_texts_attributes_${index}_course_id`
			target.querySelector(
				".course_id"
			).name = `forms_purchase_applications_edit[texts_attributes][${index}][course_id]`
			target.querySelector(
				".reason_kind"
			).id = `forms_purchase_applications_edit_texts_attributes_${index}_reason_kind`
			target.querySelector(
				".reason_kind"
			).name = `forms_purchase_applications_edit[texts_attributes][${index}][reason_kind]`
		})
	}	
}
